module.exports = __webpack_public_path__ + "static/media/aarchi.dba9f1b6.jpg";